import { AgResourceLanguage } from '../types';
import { quiz as EnUsQuiz } from '../en-us/quiz';

export const quiz: AgResourceLanguage['quiz'] = {
  ...EnUsQuiz,
  landing: {
    ...EnUsQuiz.landing,
    headline: 'Descubre si AG1 es adecuado para ti',
    body: 'No existe la dieta perfecta, y no debería ser abrumador encontrar el suplemento adecuado para satisfacer tus necesidades nutricionales diarias. Haz clic para descubrir cómo AG1 puede apoyarte en tu viaje hacia la salud.',
    bodySubtext: '',
    caption: 'Esta herramienta no está diseñada para diagnosticar o tratar ninguna condición',
    start: 'Comienza Ahora'
  },
  chart: {
    ...EnUsQuiz.chart,
    title: 'Comienza con tu paquete de bienvenida gratuito de AG1**',
    subtitle:
      'AG1 ofrece 75 vitaminas, probióticos e ingredientes de alimentos integrales para sentar las bases de la salud mental y física sin comprometer la calidad.*'
  },
  tooltip: {
    title: '¿SABÍAS QUE?'
  },
  ensureModal: {
    title: '¿Aún no estás seguro?',
    subtitle: 'Mira lo que otros dicen sobre los beneficios de AG1',
    reviews: 'Leer Opiniones',
    reject: 'No, gracias'
  },
  processModal: {
    title: 'Recibe la información más reciente',
    subtitle:
      'Al suscribirte a las noticias de AG1, obtendrás acceso a los mejores consejos, asesoramiento experto y la información más reciente sobre salud.',
    signUpText: 'Suscríbete ahora',
    signUpSuccess: 'Gracias, ¡estás suscrito!',
    signUpReject: 'No, gracias'
  },
  policy: {
    title:
      'Al ingresar tu dirección de correo electrónico, aceptas recibir comunicaciones de marketing de Athletic Greens y que esta información se procese de acuerdo con nuestra',
    button: 'Política de Privacidad'
  },
  valueChart: {
    title: 'Siente el poder de Uno',
    subtitle:
      'AG1 combina 75 ingredientes de alta calidad en una sola cucharada poderosa, eliminando la necesidad de suplementos individuales.',
    tableHead1: 'AG1 puede reemplazar:',
    tableHead2: 'Costo por mes',
    caption:
      'Basado en los datos disponibles actualmente sobre precios promedio de suplementos premium en la industria',
    buttonText: 'Continuar'
  },
  results: {
    button: 'Prueba AG1 Ahora'
  }
};
